// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2Vxgn","title":"FrontImage_title__3LsF3"};